/**
 * Obtiene la fecha de vencimiento de una compra.
 * Si el backend la devuelve, se usa. Si no, se calcula: fecha factura + días del término.
 * @param {Object} purchase - { due_date?, purchase_date?, terms_type?: { days }, days? }
 * @returns {string|null} YYYY-MM-DD o null
 */
export function getDueDate(purchase) {
  if (purchase?.due_date) return purchase.due_date;
  const dateStr = purchase?.purchase_date;
  const days =
    purchase?.terms_type?.days ??
    purchase?.terms_days ??
    purchase?.days ??
    0;
  if (!dateStr) return null;
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + Number(days || 0));
  return d.toISOString().split('T')[0];
}

/**
 * Calcula la fecha de vencimiento a partir de fecha y días.
 * @param {string} dateStr - YYYY-MM-DD
 * @param {number} days - días a sumar (0 = contado)
 * @returns {string} YYYY-MM-DD
 */
export function computeDueDate(dateStr, days) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + Number(days || 0));
  return d.toISOString().split('T')[0];
}
